/**
 * Runtime env config from window._env_ (set by env-config.js; in cloud from Key Vault).
 * Typed shape and getter so consumers get consistent defaults and keys.
 */

import { DEFAULT_API_BASE_URL, ENV_NAMES } from './constants.js';

/**
 * Shape of window._env_ (and process.env overrides at build time).
 * Keys match env-config.js / docker-entrypoint output.
 */
export const ENV_CONFIG_DEFAULTS = {
  API_BASE_URL: DEFAULT_API_BASE_URL,
  ENVIRONMENT: ENV_NAMES.DEV,
  BRANCH_CODE: '',
  REACT_APP_LOG_LEVEL: '',
  REACT_APP_ENVIRONMENT: '',
  BESPER_AI_LAB_URL: '',
  /** Auth app only */
  ENTRA_ADMIN_CLIENT_ID: '',
  AZURE_TENANT_ID: '',
  ENABLE_AUTH: 'false',
};

/**
 * Get runtime env config from window._env_ with fallbacks to process.env and defaults.
 * Safe to call in SSR (returns defaults if window is undefined).
 * @returns {typeof ENV_CONFIG_DEFAULTS}
 */
export function getEnvConfig() {
  const raw = typeof window !== 'undefined' ? window._env_ : null;
  const fromWindow = raw && typeof raw === 'object' ? raw : {};
  const fromProcess = typeof process !== 'undefined' && process.env ? process.env : {};

  return {
    API_BASE_URL:
      fromWindow.API_BASE_URL ?? fromProcess.REACT_APP_API_BASE_URL ?? ENV_CONFIG_DEFAULTS.API_BASE_URL,
    ENVIRONMENT:
      fromWindow.ENVIRONMENT ?? fromProcess.REACT_APP_ENVIRONMENT ?? fromProcess.NODE_ENV ?? ENV_CONFIG_DEFAULTS.ENVIRONMENT,
    BRANCH_CODE: fromWindow.BRANCH_CODE ?? fromProcess.REACT_APP_BRANCH_CODE ?? ENV_CONFIG_DEFAULTS.BRANCH_CODE,
    REACT_APP_LOG_LEVEL:
      fromWindow.REACT_APP_LOG_LEVEL ?? fromProcess.REACT_APP_LOG_LEVEL ?? ENV_CONFIG_DEFAULTS.REACT_APP_LOG_LEVEL,
    REACT_APP_ENVIRONMENT:
      fromWindow.REACT_APP_ENVIRONMENT ?? fromProcess.REACT_APP_ENVIRONMENT ?? ENV_CONFIG_DEFAULTS.REACT_APP_ENVIRONMENT,
    BESPER_AI_LAB_URL:
      fromWindow.BESPER_AI_LAB_URL ?? fromProcess.REACT_APP_BESPER_AI_LAB_URL ?? ENV_CONFIG_DEFAULTS.BESPER_AI_LAB_URL,
    ENTRA_ADMIN_CLIENT_ID:
      fromWindow.ENTRA_ADMIN_CLIENT_ID ?? fromProcess.REACT_APP_ENTRA_ADMIN_CLIENT_ID ?? ENV_CONFIG_DEFAULTS.ENTRA_ADMIN_CLIENT_ID,
    AZURE_TENANT_ID:
      fromWindow.AZURE_TENANT_ID ?? fromProcess.REACT_APP_AZURE_TENANT_ID ?? ENV_CONFIG_DEFAULTS.AZURE_TENANT_ID,
    ENABLE_AUTH: fromWindow.ENABLE_AUTH ?? fromProcess.REACT_APP_ENABLE_AUTH ?? ENV_CONFIG_DEFAULTS.ENABLE_AUTH,
  };
}
